<template>
  <v-container class="main-container sn-shadow-depth-02">
    <v-row class="d-flex flex-nowrap go-mobile-container">
      <phone-mock
        class="phone-mock mt-md-16 mt-lg-0"
        :servicer="servicer"
      />
      <section class="go-mobile-text">
        <h1
          class="sn-h1 sn-text-primary-03"
          data-cy="go-mobile-header"
        >
          {{ splashMobileHeader }}
        </h1>
        <p
          class="left-highlight sn-body-1"
          data-cy="go-mobile-subheader"
          :style="`border-left: 4px solid ${this.$vuetify.theme.themes.light.primary}`"
        >
          {{ splashMobileSubheader }}
        </p>
        <ul
          class="list mt-6 pl-1 sn-body-1"
          data-cy="go-mobile-checklist"
        >
          <li
            v-for="bulletText in splashMobileBullets"
            :key="bulletText"
            class="mt-7"
            :data-cy="bulletText + '-list-item'"
          >
            <v-icon
              class="mr-3"
              size="24"
              :color="$vuetify.theme.themes.light.primary"
            >
              sn-icon-check-circle
            </v-icon>
            {{ bulletText }}
          </li>
        </ul>
        <action-input
          :mask="phoneMask"
          :label-text="splashMobileNumber"
          :button-text="splashAppSendMsg"
          data-cy="go-mobile-phone-input"
          type="tel"
          :rules="phoneRules"
          @action-btn-clicked="sendSMS"
        />
        <p
          class="sn-caption sn-text-primary-01"
          data-cy="go-mobile-legal-restrictions"
        >
          {{ splashLegalRestrictions }}
        </p>
      </section>
    </v-row>
    <sn-toast
      v-model="toast.active"
      :event="toast.event"
      :message="toast.message"
      :description="toast.description"
    />
  </v-container>
</template>

<script>
import ActionInput from '../Form/ActionTextInput.vue'
import PhoneMock from './PhoneMock.vue'
import snUtilService from '~/services/snUtilService.js'

export default {
  name: 'GoMobileWrapper',
  components: {
    ActionInput,
    PhoneMock
  },
  props: {
    servicer: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      phoneRules: [
        (v) =>
          /^(\(?\d{3}\)?-?\d{3}-?\d{4}|\(?\d{3}\)?.?\d{3}.?\d{4}|\d{10})$/.test(
            v
          ) || this.splashPhoneInputError
      ],
      phoneMask: '(###) ###-####',
      toast: {
        active: false,
        event: null,
        message: '',
        description: ''
      }
    }
  },
  computed: {
    splashMobileHeader () {
      return this.$store.borrowerWebContent?.splashMobileHeader
    },
    splashMobileSubheader () {
      return this.$store.borrowerWebContent?.splashMobileSubheader
    },
    splashMobileBullets () {
      return this.$store.borrowerWebContent?.splashMobileBullets
    },
    splashMobileNumber () {
      return this.$store.borrowerWebContent?.splashMobileNumber
    },
    splashAppSendMsg () {
      return this.$store.borrowerWebContent?.splashAppSendMsg
    },
    splashLegalRestrictions () {
      return this.$store.borrowerWebContent?.splashLegalRestrictions
    },
    splashPhoneInputError () {
      return this.$store.borrowerWebContent?.splashPhoneInputError
    },
    code () {
      return this.$route.params.code
    }
  },
  methods: {
    sendSMS (inputText) {
      this.loading = true
      if (inputText) {
        const phone = inputText.replace(/\D/g, '')
        const code = this.code

        snUtilService
          .shareAppBySms(phone, code, 'borrower_invitation', 'landing_page')
          .then(() => {
            this.loading = false
            this.toast.active = true
            this.toast.event = 'success'
            this.toast.message = 'Message sent successfully'
          })
          .catch(() => {
            this.loading = false
            this.toast.active = true
            this.toast.event = 'error'
            this.toast.message = 'Failed to send message'
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "~/assets/css/snui";

::v-deep.main-container {
  padding: 0 55px;
  position: relative;
  overflow: hidden;
  min-height: 575px;

  .go-mobile-container {
    bottom: 0px;
    width: 100%;
    flex-grow: 0;
    min-height: 575px;
  }
}
.phone-mock {
  box-shadow: $sn-shadow-depth-2;
  height: 100%;
}
.go-mobile-text {
  position: relative;
  margin-top: 55px;
  margin-left: 80px;
}
.left-highlight {
  padding-left: 12px;
  margin-top: 21px;
}
.list {
  list-style: none;
  margin-bottom: 25px;
}

@media (max-height: 1520px) {
  ::v-deep.main-container {

    .go-mobile-container {
      position: relative;
      bottom: 0px;
    }
  }
}
</style>
